import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MulticlientInfoItem } from '../model/multiclient';

@Injectable({
  providedIn: 'root'
})
export class MulticlientService {

  PATH = '/Users/MultiClient';
  SWITCH_PATH = '/Users/SwitchClient/';

  constructor(
    private http: HttpClient
  ) { }

  getMulticlientInfo(): Observable<MulticlientInfoItem[]> {
    return this.http.get(`${environment.API_BASE}${this.PATH}`).pipe(first())
      .pipe(map((infos: any[]) => infos.map(info => MulticlientInfoItem.toModel(JSON.stringify(info)))));
  }

  switchClient(clientId: number): Observable<any> {
    return this.http.post(`${environment.API_BASE}${this.SWITCH_PATH}${clientId}`, undefined).pipe(first());
  }
}
